/**
 * Turns a scraped provider page summary (flattened markdown) into tidy
 * blocks: an overview paragraph plus question/answer pairs.
 */
export type SummaryBlock = { heading?: string; text: string };

const CTA = /^(schedule|register|book|enrol|enroll|sign up|buy|start|learn more|get started)/i;

function strip(s: string): string {
  return s
    .replace(/!\[[^\]]*\]\([^)]*\)/g, " ")                 // images
    .replace(/\[([^\]]*)\]\([^)]*\)/g, (_m, t: string) => (CTA.test(t.trim()) ? " " : t)) // links
    .replace(/https?:\/\/\S+/g, " ")
    .replace(/[*_`>|]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function cleanSummary(raw: string | null | undefined, title?: string): SummaryBlock[] {
  if (!raw) return [];
  const norm = (s: string) => s.toLowerCase().replace(/[^a-z0-9]/g, "");
  const t = title ? norm(title) : "";
  const chunks = raw.split(/#{1,6}\s+/).map(strip).filter(Boolean);
  const out: SummaryBlock[] = [];
  for (let c of chunks) {
    if (/^key faqs?/i.test(c)) c = c.replace(/^key faqs?[^.?!]*?(get started|started)?\s*/i, "").trim();
    if (!c) continue;
    const q = c.indexOf("?");
    if (q > 0 && q < 140) {
      const answer = c.slice(q + 1).trim();
      if (answer) { out.push({ heading: c.slice(0, q + 1), text: answer }); continue; }
    }
    // Drop a leading repeat of the title.
    if (t) {
      const words = c.split(" ");
      for (let n = Math.min(words.length, 12); n > 0; n--) {
        if (norm(words.slice(0, n).join(" ")) === t) { c = words.slice(n).join(" ").trim(); n = Math.min(c.split(" ").length, 12) + 1; if (!c) break; words.splice(0, words.length, ...c.split(" ")); }
      }
    }
    if (c.length < 25) continue;
    const prev = out[out.length - 1];
    if (prev && !prev.heading) prev.text += " " + c; else out.push({ text: c });
  }
  return out.slice(0, 6);
}
